import {liveEditorStrings} from "./live-editor-strings-lingui.tsx";

/**
 * Load the live editor i18n strings.
 *
 * This is used to translate messages in the live editor, without loading Lingui.
 * Ideally we'd rewrite the live editor to use strings that
 * are passed in from webapp, like we do for math-input and perseus, but that will take
 * a lot of work on some very fragile code. So this is the safer option.
 *
 * @returns An object with the `_` and `ngettext` functions for translating messages.
 */
export const loadLiveEditorI18n = () => {
    const translated = liveEditorStrings();
    return {
        _: (message: string, args: Record<string, any>) => {
            if (message in translated) {
                const translation = translated[message];
                return typeof translation === "function"
                    ? translation(args)
                    : translation;
            }

            return message;
        },

        ngettext: (
            singular: string,
            plural: string,
            num: number,
            args: Record<string, any>,
        ) => {
            if (singular in translated) {
                return translated[singular]({num, ...args});
            }

            return singular;
        },
    };
};
